/**
 * @module location 
 *  Apis must need auth details to trigger url - NormalApis
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApis from '@/Components/Controllers/NormalApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
    /**
     * Fetch all
     */
    fetchAll(businessId) {
        //const url = `${Env.locationUrl}/api/v1/locations/businesses/${businessId}`; // old route
        const url= `${Env.locationUrl}/api/v1/locations?page=1&limit=25`; // new route
        return NormalApis.getApi(url, {
              'api-token': Env.apiToken,
              'auth-token': Env.authToken,
            })
            .then(res => {
                store.dispatch('location/setList', res.data.payload);
                return res.data.payload;
            })
            .catch(err => err);
    },

    /**
     * Fetch by ID
     */
    fetchByID(id) {
      const url = `${Env.locationUrl}/integrators/locations/${id}`; // ?include_profile=1&include_hours=1&include_location_order_configuration=1&include_delivery_profile=1
      return NormalApis.getApi(url, {
          'api-token': Env.apiToken,
          'auth-token': Env.authToken,
        })
        .then(res => res)
        .catch(err => err);
    },

    /**
     * Fetch Nearest
     */
    async fetchNearest(userAddress = {}, save = true) {
        let businessProfile = store.getters['businessprofile/detail'];
        let businessId =  businessProfile.id;
        if(businessProfile.id == ''){
          return false;
        }
      
        // If empty user address then lets fetch it from api
      if(_.isEmpty(userAddress)){
        let getuserLocationLatLng = await this.getUserLatAndLng();
        if(getuserLocationLatLng.data && getuserLocationLatLng.data.location && getuserLocationLatLng.data.location.lat){
          let getuserLocationAddress = await this.getAddressFromLatLng(getuserLocationLatLng.data.location.lat, getuserLocationLatLng.data.location.lng);
          if(getuserLocationAddress.status == 200){
              let fetchedUserAddress = {
                formatted_address: getuserLocationAddress.data.results[0].formatted_address,
                geometry: {
                  location: {
                    lat: getuserLocationLatLng.data.location.lat,
                    lng: getuserLocationLatLng.data.location.lng,
                  }
                },
              };
              store.dispatch('location/setUserAddress', fetchedUserAddress)
              userAddress = fetchedUserAddress.geometry;
            } else {
              console.log('Unable to fetch user location from google.')
              return;
            }
          }
        }
   
        // let url = `${Env.locationUrl}/locations/search/nearby`;
        let url = `${Env.locationUrl}/clients/businesses/${businessId}/locations/search/nearby`;
        if (userAddress != '') {
            let lat;
            let lng;
            // get my location
            if (typeof userAddress.location.lat === 'function') {
                lat = userAddress.location.lat();
                lng = userAddress.location.lng();
            } else {
                lat = userAddress.location.lat;
                lng = userAddress.location.lng;
            }
            let radius = 500000;
            // We need to pass setting true because we are setting first item as selected location so if no setting checkout wont find setting for calculation
            url += `?lat=${lat}&long=${lng}&radius=${radius}&operation_hours=true&address=true&contact_details=true&settings=true&images=true&delivery_hours=false&timeslots=false`;
        }
            // } else {
        //    url += `?radius=5000000&operation_hours=true&address=true&contact_details=true&settings=true&images=true&delivery_hours=true&timeslots=true`;
        // }
        return NormalApis.getApi(url, {
          'api-token': Env.apiToken,
          'auth-token': Env.authToken,
         })
          .then(res => {
              if (save) {
                store.dispatch('location/setNearby', {
                  locations: res.data.payload
                });
              }
              return res;
          })
          .catch(err => {
            // If error set blank location
            store.dispatch('location/setNearby', {
              locations: []
            });
            return err;
          });
    },
    /**
     * Fetch by slug
     */
    fetchBySlug(slug, justDetail = false) {
       // just func name Id its fetch from Slug
       let businessProfile = store.getters['businessprofile/detail'];
       let businessId = businessProfile.id;
        if(!slug || !businessId){
          console.log( 'business id or location slug not found');
          return false;
        }
     
       // old  const url = `${Env.locationUrl}/api/v1/locations/slug/${slug}?include_profile=1&include_hours=1&include_location_order_configuration=1&include_delivery_profile=1`;
       //const url = `${Env.locationUrl}/locations/slug/search?contactDetails=true&address=true&settings=true&images=true&hours=true&clientFormat=true&include_profile=1&include_hours=1&include_location_order_configuration=1&include_delivery_profile=1`;
       // const url = `${Env.locationUrl}/clients/businesses/${businessId}/locations/${slug}?operation_hours=true&address=true&contact_details=true&settings=true&images=true&delivery_hours=true`
      let url = `${Env.locationUrl}/clients/businesses/${businessId}/locations/${slug}?operation_hours=true&address=true&contact_details=true&settings=true&images=true&delivery_hours=true`;
      if(justDetail){
        url = `${Env.locationUrl}/clients/businesses/${businessId}/locations/${slug}`;
      } 

      return NormalApis.getApi(url, {
        'api-token': Env.apiToken,
        'auth-token': Env.authToken,
      })
      .then(res => res)
      .catch(err => err);
    },

   /**
   * 
   * Get all location categories
   */
    fetchAllLocationCategories(location_id) {
      const url = `${Env.productUrl}/api/v1/locationCategories/${location_id}/getAll`;
      return NormalApis.getApi(url, {
          "app-id": Env.productAppId,
          "app-secret": Env.productAppSecret
      })
      .then(res => res)
      .catch(err => err);
    },
    
    /**
     * Fetch business -> location payment setting
     */
    fetchLocationPaymentSettings(locationId) {
      let businessProfile = store.getters['businessprofile/detail'];
      let businessId =  businessProfile.id;
      const url = `${Env.locationUrl}/integrators/businesses/${businessId}/locations/${locationId}/settings`;
      return NormalApis.getApi(url, {
        'api-token': Env.apiToken,
        'auth-token': Env.authToken,
      })
      .then(res =>  res)
      .catch(err => err);
    },

    /**
     * Fetch by slug
     */
    fetchByUUID(id) {
      // old  const url = `${Env.locationUrl}/api/v1/locations/show/${id}?include_profile=1&include_hours=1&include_location_order_configuration=1&include_delivery_profile=1`;
      //const url = `${Env.locationUrl}/api/v1/locations/slug/${slug}?include_profile=1&include_hours=1`;
      const url = `${Env.locationUrl}/locations/${id}?include_profile=1&include_hours=1&include_location_order_configuration=1&include_delivery_profile=1`;
      return NormalApis.getApi(url, {
              'api-token': Env.apiToken,
              'auth-token': Env.authToken,
          })
          .then(res => res)
          .catch(err => err);
    },


    /**
     * Fetch location featured products
     */
    featuredProducts(location_id, filters = null) {
      // const url = `${Env.productUrl}/api/v1/locationProducts/${location_id}/byLocation?featured=1&include_brands=1&include_variants=1&include_reviews=1&include_cannabis_attributes=1&include_thc_cbd=1${filters ? filters : ''}`;
      const url = `${Env.productUrl}/api/v1/locationProducts/${location_id}/byLocation?featured=1&available=all&include_brands=1&include_variants=1&include_cannabis_attributes=1&include_thc_cbd=1&include_location_product_category=1${filters ? filters : ''}`;
      return NormalApis.getApi(url, {
              "app-id": Env.productAppId,
              "app-secret": Env.productAppSecret
          })
          .then(res => res)
          .catch(err => err);
    },

    /**
     * Fetch location category products
     */
    categoryWithProducts(location_id, filters = null, noSubcat  = false) {
      if(!location_id)
      return;
      let newF  = '';
      if(noSubcat && filters) {
        
        let fil = filters.split('&');
        fil.forEach(d => {
          if(d.indexOf('from_categories')  == -1){
            newF  = '&'+d;
          }
        })
      }  else {
        newF  = filters;
      }
      const url = `${Env.productUrl}/api/v1/locationCategories/${location_id}/location?include_products=1&available=all&include_brands=1&include_variants=1&include_cannabis_attributes=1&include_thc_cbd=1&include_location_product_category=1&featured_categories=0&include_aromas=1${newF ? newF : ''}`;
      return NormalApis.getApi(url, {
              "app-id": Env.productAppId,
              "app-secret": Env.productAppSecret
          })
          .then(res => res)
          .catch(err => err);
    },

    /**
     * Fetch location category only
     */
    locationCategoriesOnly(location_id) {
      if(!location_id)
      return;

      const url = `${Env.productUrl}/api/v1/locationCategories/${location_id}/location?include_products=1&available=all&include_variants=1&featured_categories=0`;
      return NormalApis.getApi(url, {
              "app-id": Env.productAppId,
              "app-secret": Env.productAppSecret
          })
          .then(res => res)
          .catch(err => err);
    },

    /**
     * Fetch location featured category products
     */
    featuredCategoryWithProducts(location_id) {
      if(!location_id)
      return;
      // new api api/v1/locationCategories/80cd0a5a-c90d-4afd-aba6-05851f8df588/featuredCategories
      // old api const url = `${Env.productUrl}/api/v1/locationCategories/${location_id}/location?include_products=1&available=all&include_brands=1&include_variants=1&include_cannabis_attributes=1&include_thc_cbd=1&featured_categories=1&include_location_product_category=1`;
      const url = `${Env.productUrl}/api/v1/locationCategories/${location_id}/featuredCategories?include_products=1&available=all&include_brands=1&include_variants=1&include_cannabis_attributes=1&include_thc_cbd=1&include_location_product_category=1`;
      return NormalApis.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => res)
      .catch(err => err);
    },
    

    /**
     *  Location time slots
     */

    timeSlots(locationSlug, type = 'pickup') {
        let businessProfile = store.getters['businessprofile/detail'];
        let businessId =  businessProfile.id;
       // const url = `${Env.locationUrl}/api/v1/locations/${locationId}/timeslots?type=${type}`;
        const url = `${Env.locationUrl}/clients/businesses/${businessId}/locations/${locationSlug}/timeslots?${type == 'delivery' ? 'delivery_timeslots=true' : 'pickup_timeslots=true'}`;
        return NormalApis.getApi(url, {
          'api-token': Env.apiToken,
          'auth-token': Env.authToken,
        })
        .then(res => res)
        .catch(err => err);
    },

    /**
     * 
     * get user lat and lng
     */
    getUserLatAndLng() {
      const url = `https://www.googleapis.com/geolocation/v1/geolocate?key=${Env.googleMapKey}`;
      return NormalApis.postApi(url, {}, {})
          .then(res => res)
          .catch(err => err);
    },
    
    /** 
     * get address from lat lng
     */
    getAddressFromLatLng(lat, lng) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${Env.googleMapKey}`;
        return NormalApis.getApi(url, {}, {})
            .then(res => res)
            .catch(err => err);
    },

    /**
     * Locate user from browser changed to api
     */
    async locateUser() {

        try {
          let getuserLocationLatLng = await this.getUserLatAndLng();
          let getuserLocationAddress = await this.getAddressFromLatLng(getuserLocationLatLng.data.location.lat, getuserLocationLatLng.data.location.lng);
            // let data = await this.getLocation();
            // let res = await this.getAddressFromLatLng(data.coords.latitude, data.coords.longitude);
            if (getuserLocationAddress.status == 200) {
              return {
                  status: 200,
                  lat: getuserLocationLatLng.data.location.lat,
                  lng: getuserLocationLatLng.data.location.lng,
                  address: getuserLocationAddress.data.results[0].formatted_address,
                  message: 'Location set successfully.'
              }
            } else {
                return {
                    status: 422,
                    message: 'Error handling request.'
                }
            }
        } catch (e) {
            return {
                status: 422,
                message: e.message
            }
        }

    },

    /**
     * Geolocation get detail
     */
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
            reject(new Error('Geolocation is not available.'));
        }
        navigator.geolocation.getCurrentPosition(pos => {
            resolve(pos);
        }, err => {
            reject(err);
        });
      });
    },

    /**
     * Get location Category sizes
     */
     getLocationCategorySizes(locationId, filters = null) {
      const url = `${Env.productUrl}/api/v1/locationCategories/${locationId}/getsize${ filters ? filters : ''}`;
      return NormalApis.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => res.data.payload)
      .catch(err => []);
    },
    /**
     * Get location delivery fee
     */
     getLocationDeliveryFee({
      location_id, lat, lng, cart_total
     }) {
      const url = `${Env.locationUrl}/locations/${location_id}/delivery_fee?lat=${lat}&long=${lng}&cart_total=${cart_total}`;
      return NormalApis.getApi(url, {
        'api-token': Env.apiToken,
        'auth-token': Env.authToken,
      })
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Fetch location clover api token
     * 
     */
    getLocationCloverApiToken(location_id) {
      const url= `${Env.locationUrl}/integrators/locations/${location_id}/clover/apiKey`;
      return NormalApis.getApi(url, {
        'api-token': Env.apiToken,
      })
      .then(res => res)
      .catch(err => err);

    },
  
}